import React from "react";
import { Grid, MenuItem } from "@mui/material";

import {
  Autocomplete,
  AutocompleteMultiSelect,
  ComponentHeader,
  Paper,
  TextField,
} from "../../../components";
import {
  controlText,
  dateTime,
  dropDown,
  fileControl,
  range,
} from "./customFieldsDetailsObject";

export default function MainForm({
  groups,
  formikProps,
  controlTypes,
  editState,
  PlatformTenantList,
}) {
  const handleChangeControl = (event) => {
    let controlID = event.target.value;
    if (parseInt(controlID) === 1) {
      range(formikProps, controlID);
    }

    if (parseInt(controlID) === 3) {
      controlText(formikProps, controlID);
    }

    if (parseInt(controlID) === 4) {
      dateTime(formikProps, controlID);
    }
    if (parseInt(controlID) === 2) {
      dropDown(formikProps, controlID);
    }

    if (parseInt(controlID) === 5) {
      fileControl(formikProps, controlID);
    }
  };

  function handleChangeGroup(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        groupID: value.id,
      }));
    } else {
      value = {
        id: "",
        label: "",
      };
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        groupID: value.id,
      }));
    }
  }
  return (
    <React.Fragment>
      <Paper>
        <Grid size={12}>
          <ComponentHeader title="General Settings" />
        </Grid>

        <Grid size={6}>
          <TextField
            select
            required
            name="controlID"
            label="Component Type"
            formikProps={formikProps}
            disabled={!editState || !!formikProps.values.ID}
            onChange={handleChangeControl}
          >
            {controlTypes.map((item) => (
              <MenuItem
                key={parseInt(item.field_type_id)}
                value={item.field_type_id}
              >
                {item.field_type_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid size={6}>
          <AutocompleteMultiSelect
            required
            label={"Select Platform Tenant"}
            name={"platforms"}
            defaults={{
              primaryKey: "platform_id",
              displayLabel: "platform_name",
            }}
            formikProps={formikProps}
            options={PlatformTenantList}
            disabled={!editState}
            forcePopupIcon={!editState ? false : true}
            placeholder="Select Platform Tenant"
            onChange={(_, arr, reason, option) => {
              handleChange(arr, option, reason, "platforms", "platform_name");
            }}
          />
        </Grid>

        <Grid size={6}>
          <Autocomplete
            label={"Select Group"}
            name={"groupID"}
            defaults={{
              primaryKey: "id",
              displayLabel: "label",
            }}
            formikProps={formikProps}
            options={groups}
            disabled={!editState}
            onChange={(_, value, type) => handleChangeGroup(value, type)}
          />
        </Grid>

        <Grid size={6}>
          <TextField
            required
            select
            formikProps={formikProps}
            name="isActive"
            label="Custom Field Status"
            disabled={!editState}
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </TextField>
        </Grid>
      </Paper>

      <Paper>
        <Grid size={12}>
          <ComponentHeader title={"Field Configuration"} />
        </Grid>

        <Grid size={6}>
          <TextField
            required
            formikProps={formikProps}
            name="label"
            label="Custom Field Label"
            disabled={!editState}
          />
        </Grid>

        <Grid size={6}>
          <TextField
            formikProps={formikProps}
            name="tooltip"
            label="Custom Field Tooltip"
            disabled={!editState}
          />
        </Grid>

        <Grid size={6}>
          <TextField
            required
            formikProps={formikProps}
            name="description"
            label="Custom Field Description"
            disabled={!editState}
          />
        </Grid>

        <Grid size={6}>
          <TextField
            required
            formikProps={formikProps}
            name="name"
            label="Field Name"
            disabled={!editState}
          />
        </Grid>
      </Paper>
    </React.Fragment>
  );

  function handleChange(arr, { option }, reason, name, displayName) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [name]: setValuesOfDropDown(prevVal[name]),
    }));

    function setValuesOfDropDown(val) {
      let values = !Array.isArray(val) ? [] : [...val];

      const index = values.indexOf(option["platform_id"]);
      if (index > -1) {
        values.splice(index, 1);
      } else {
        values.push(option["platform_id"]);
      }

      return values;
    }
  }
}
